export default "__VITE_ASSET__a73078a1__"